/* eslint-disable */
import {
    Card,
    CardContent,
    Grid,
    RACButton,
    RACCheckBox,
    RACDatePicker,
    RACModalCard,
    RACRadio,
    RACSelect,
    RACTextbox,
    RACTooltip,
    Typography,
} from '@rentacenter/racstrap';
import React, { useContext, useEffect, useState } from 'react';
import { CostBasedPricingStyles } from '../Styles/CostBasedPricing';
import { ZoneBasedPricingContext } from './ZoneBasedPricingContext';
import { filterHierarchy, mapDropDownData } from '../../../utils/utils';
import { ReactComponent as Info } from '../../../assets/images/info-button.svg';
import { ReactComponent as RightAngle } from '../../../assets/images/angleRight.svg';
import { addPricingQueueAPI } from '../../../api/user';
import moment, { Moment } from 'moment';
import { DropDownData } from '../../shared/interface/CostBasedPricingInterface';
import { MultiSelect } from 'react-multi-select-component';
import { ReactComponent as WarningIcon } from "../../../assets/images/no-records-found.svg";
import { ZoneBasedFormData, ErrorMessage } from '../../shared/interface/ZoneBasedPricingInterface';

export default function ZoneBasedPricingForm(props: any) {
    console.log(props, 'propssssssss')
    const classes = CostBasedPricingStyles();
    const { deptFormOptions, subDeptFormOptions, setsubDeptFormOptions,
        bracketFormOptions, setbracketFormOptions, zoneOptions, loader, setLoader,
        dropDownData, setDisplayGrid, pageDisplay, zoneBasedPricingFormData, setZoneBasedPricingFormData,
        setDisplayForm, errorMessage, setErrorMessage, setPricingQueueId, zoneBasedFormData,
        setHandlePopup, handlePopup, userInfo, formZoneSelected, setFormZoneSelected,
        checked, setChecked
    } = useContext(ZoneBasedPricingContext);
    const [popup, setPopup] = useState<boolean>(false)
    const [isEditScreen, setIsEditScreen] = useState<boolean>(false);
    const currentDate = moment(moment(new Date()).format("YYYY-MM-DD"), "YYYY-MM-DD");
    const startDate = zoneBasedPricingFormData.startDate && moment(zoneBasedPricingFormData.startDate, "YYYY-MM-DD");
    const endDate = zoneBasedPricingFormData.endDate && moment(zoneBasedPricingFormData.endDate, "YYYY-MM-DD");
    const comparisonDate = moment("2099-12-31", "YYYY-MM-DD");
    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
    const endDateDisable = endDate && endDate.isSame(comparisonDate, 'day')
    const isDeptLevel = ((zoneBasedPricingFormData?.department) && (!zoneBasedPricingFormData?.subdepartment) && (!zoneBasedPricingFormData?.bracket));
    const endDateMin = ((!isEditScreen) || (isDeptLevel && isEditScreen)) ? moment().format('YYYY-MM-DD') : moment().subtract(1, 'days').format('YYYY-MM-DD');

    useEffect(() => {
        setsubDeptFormOptions(mapDropDownData(dropDownData?.subdepartment, "descEn", 'subdepartmentNumber'));
        setbracketFormOptions(mapDropDownData(dropDownData?.bracket, "descEn", 'bracketNumber'));
        if (props?.formData != undefined) {
            setIsEditScreen(true);
            setZoneBasedPricingFormData(props.formData)
            const zoneItem = dropDownData.zone?.filter((item: DropDownData) => {
                return item.value == props?.formData?.zoneNumber
            }).filter(Boolean)
            setFormZoneSelected(zoneItem)
            const checked = props?.formData?.reCalculateTerm == 'Yes' ? true : false
            setChecked(checked)
        }
    }, [])

    const checkAllKeysHaveValue = (data: ZoneBasedFormData, errorMessage: ErrorMessage): boolean => {
        let boolean = false;
        const recalTerm = props?.formData?.reCalculateTerm;
        if ((data.zoneNumber && data.departmentNumber && data.startDate && data.endDate && data.publishPriceForExisitingRMS && data.schedule)
            && (data.termPrem || data.turn || ((!isEditScreen ? data.reCalculateTerm == 'Yes' ? true : false : false) ||
                (isEditScreen ? recalTerm == 'Yes' ? true : (recalTerm == 'No' || !recalTerm) ? data.reCalculateTerm == 'Yes' ? true
                    : false : false : false)) || data.newAndUsedRatePrem || data.brandNewRatePrem)) {
            boolean = true
        }
        const errorCheck = Object.values(errorMessage).every(value => value === '');
        return boolean && errorCheck
    };

    function bindHierarchyDropDown(data: any[], filterKey: string, value: string | number, type: string) {
        const filteredData = filterHierarchy(data, filterKey, value);
        const dropDownData = mapDropDownData(filteredData, "descEn", type);
        if (type == 'subdepartmentNumber') {
            setsubDeptFormOptions(dropDownData)
        } else if (type == 'bracketNumber') {
            setbracketFormOptions(dropDownData)
        }
    }

    function onChangeField(key: string, value: any) {
        setZoneBasedPricingFormData({ ...zoneBasedPricingFormData, [key]: value })
    }

    async function submitFunction(endConfigure?: boolean) {
        setLoader({ ...loader, mainPage: true });
        const pricingRuleDetailsReq = formAddPricingQueueRequest(zoneBasedPricingFormData, endConfigure)
        console.log(pricingRuleDetailsReq, 'pricingRuleDetailsReq')
        let req = {
            schedule: zoneBasedPricingFormData.schedule,
            status: "WAITING",
            submittedBy: userInfo.userName,
            type: "ZONERULES",
            companyCode: userInfo.companyCode?.length ? userInfo.companyCode[0] : undefined,
            queueData: {
                pricingRuleDetails: pricingRuleDetailsReq
            }
        }
        const response = await addPricingQueueAPI(req);
        console.log(response, 'addpricresponse')
        setLoader({ ...loader, mainPage: false });
        setDisplayForm(false)
        if (pageDisplay != 0) {
            setDisplayGrid(true)
        } else {
            setDisplayGrid(false)
        }
        if (response.status == 200) {
            setZoneBasedPricingFormData(zoneBasedFormData)
            setPricingQueueId(response.data.pricingQueueId)
            setHandlePopup({ ...handlePopup, isOpen: true, Content: 'Request has been submitted.', type: 'success' })
        }
        else if (response.status == 400) {
            const content = response.data?.errors[0]?.error?.trim()?.length > 0 ? response.data?.errors[0]?.error?.trim() : 'Something went wrong';
            setHandlePopup({ isOpen: true, Content: content, index: 0, type: 'error' });
        } else {
            const content = response.data?.errors[0]?.error?.trim()?.length > 0 ? response.data?.errors[0]?.error?.trim() : 'Something went wrong'
            setHandlePopup({ isOpen: true, Content: content, index: 0, type: 'error' });
        }
    }

    function breadCrums() {
        return (
            <>
                <Typography variant='body1' className={`${classes.greyColor} ${classes.fs12} ${classes.cursorStyle}`}>
                    <span onClick={() => {
                        setDisplayForm(false)
                        if (pageDisplay != 0) {
                            setDisplayGrid(true)
                        } else {
                            setDisplayGrid(false)
                        }
                    }}> Zone Based Pricing Details </span>
                    <span className={`${classes.ml10}`}><RightAngle className={`${classes.h10}`} style={{ color: 'grey' }} /></span>
                    <span className={`${classes.ml10} ${classes.cursorStyle} ${classes.textBlue}`}
                    > {isEditScreen ? 'Update Zone Based Pricing' : ' New Zone Based Pricing'} </span>
                </Typography>
            </>
        )
    }

    function footerCard() {
        return (
            <>
                <Card style={{ position: "fixed", bottom: "0px", width: "100%", zIndex: "1", left: "0" }}>
                    <CardContent style={{ padding: '5px 10px 10px 0px' }}>
                        <Grid md={12} lg={12} sm={12} xs={12} spacing={3}>
                            <RACButton
                                variant="contained"
                                color="primary"
                                size="small"
                                style={{ float: "right", margin: '10px' }}
                                disabled={checkAllKeysHaveValue(zoneBasedPricingFormData, errorMessage) ? false : true}
                                onClick={() => {
                                    if (startDate?.isBefore(currentDate) && !(endDate.isSame(yesterday))) {
                                        setErrorMessage({ ...errorMessage, startDate: 'Start Date should not be a past date' })
                                    }
                                    else if (startDate?.isAfter(endDate) || endDate?.isSame(yesterday)) {
                                        setPopup(true)
                                    } else {
                                        submitFunction()
                                    }
                                }}
                            >
                                Submit
                            </RACButton>
                            <RACButton
                                color="primary"
                                variant="outlined"
                                size="large"
                                style={{ float: "right", margin: '10px' }}
                                onClick={() => {
                                    setDisplayForm(false)
                                    if (pageDisplay != 0) {
                                        setDisplayGrid(true)
                                    } else {
                                        setDisplayGrid(false)
                                    }
                                }}
                            >
                                Cancel
                            </RACButton>
                        </Grid>
                    </CardContent>
                </Card>
            </>
        )
    }

    const handleInputChange = (e: any, regex: RegExp, replace: RegExp) => {
        !regex.test(e.target.value)
            ? (e.target.value = e.target.value.replace(replace, ''))
            : null;
    };

    function formAddPricingQueueRequest(data: ZoneBasedFormData, endConfigure?: boolean) {
        const request = {
            zoneNumber: data.zoneNumber,
            departmentNumber: data.departmentNumber,
            subdepartmentNumber: data.subdepartmentNumber || null,
            bracketNumber: data.bracketNumber || null,
            startDate: data.startDate,
            endDate: endConfigure ? yesterday : data.endDate,
            publishPriceFlag: (data.publishPriceForExisitingRMS)?.toUpperCase(),
            zoneBasedRules: {
                termPrem: data.termPrem || null,
                turn: data.turn || null,
                reCalculateTerm: (() => {
                    if (!data.reCalculateTerm) return null;
                    const isYes = data.reCalculateTerm === 'Yes';
                    const isNo = data.reCalculateTerm === 'No';
                    if (!isEditScreen) {
                        return isYes ? 'YES' : null;
                    }
                    if (isEditScreen) {
                        const prevRecalculateTerm = props?.formData?.reCalculateTerm;
                        if (isYes || (prevRecalculateTerm === 'Yes' && isNo)) {
                            return data.reCalculateTerm.toUpperCase();
                        }
                    }
                    return null;
                })(),
                newAndUsedRatePrem: data.newAndUsedRatePrem || null,
                brandNewRatePrem: data.brandNewRatePrem || null
            }
        }
        return request;
    }


    function allowTwoDigitsAfterDot(e: any) {
        const value = String(e.target.value);
        const split = value?.includes('.') ? value?.split('.') : [];
        if (value?.[0] == '.') {
            e.target.value = '';
        } else if ((value?.[4]) && ((value?.[0] == '-') && (value?.[2] != '.') && (value?.[3] != '.') && (value?.[4] != '.'))) {
            e.target.value = e.target.value?.[0] + e.target.value?.[1] + e.target.value?.[2] + e.target.value?.[3];
        } else if ((value?.[3]) && ((value?.[1] != '.') && (value?.[2] != '.') && (value?.[3] != '.') && (value?.[0] !== '-'))) {
            e.target.value = e.target.value?.[0] + e.target.value?.[1]  + e.target.value?.[2];
        } else if (split?.[1]?.length > 2) {
            e.target.value = split[0] + '.' + split[1].slice(0, 2)
        }
    }

    function allowTwoDigitsBeforeDot(e: any) {
        const value = String(e.target.value);
        if (value?.[0] == '.' || value?.[0] == '0') {
            e.target.value = ''
        } else if ((value?.[2]) && ((value?.[1] != '.') && (value?.[2] != '.'))) {
            e.target.value = e.target.value?.[0] + e.target.value?.[1];
        } else if (value?.[1] == '.' && value[8]) {
            e.target.value = value?.slice(0, 8)
        }
    }

    function allowThreeDigits(e: any) {
        const value = String(e.target.value);
        if ((value?.[0] !== '-') && (value?.[3])) {
            e.target.value = e.target.value?.[0] + e.target.value?.[1] + e.target.value?.[2];
        }
    }

    function isValidDate(date: Moment) {
        return date?.isValid();
    }

    function dateValidation(startDate: any, endDate: any) {
        const newErrorMessage = { ...errorMessage, startDate: '', endDate: '' };
        console.log(startDate._i, endDate._i, 'endDate._i endDate._i ')
        if (startDate._i === undefined || !isValidDate(startDate)) {
            newErrorMessage.startDate = 'Start Date is not a valid date';
        }
        if (endDate._i === undefined || !isValidDate(endDate)) {
            newErrorMessage.endDate = 'End Date is not a valid date';
        }
        if (!isEditScreen && startDate && endDate && currentDate) {
            if (startDate?.isBefore(currentDate)) {
                newErrorMessage.startDate = 'Start Date should not be a past date';
            } else if (startDate && endDate && startDate?.isAfter(endDate)) {
                newErrorMessage.startDate = 'Start Date cannot be greater than End Date';
            }

            if (endDate?.isBefore(currentDate)) {
                newErrorMessage.endDate = 'End Date should not be a past date';
            } else if (endDate && startDate && endDate?.isBefore(startDate)) {
                newErrorMessage.endDate = 'End Date cannot be earlier than Start Date';
            }
        } else if (isEditScreen && startDate && endDate && currentDate) {
            if (endDate?.isSameOrAfter(currentDate) && startDate?.isBefore(currentDate)) {
                newErrorMessage.startDate = 'Start Date should not be a past date';
            } else if (endDate.isBefore(currentDate) && !endDate.isSame(yesterday)) {
                newErrorMessage.endDate = `End Date should not be a past date other than yesterday's date`;
            }
        }

        setErrorMessage(newErrorMessage);
    }

    const popUp = () => {
        return (
            <>
                <Grid>
                    <Grid style={{ justifyContent: "center", display: "flex" }}>
                        <WarningIcon width={"10%"} height={"10%"} />
                    </Grid>
                    <Grid style={{ padding: '1%' }}>
                        <Typography variant="h5" style={{ textAlign: "center", marginBottom: '3%', marginTop: '2%' }} >
                            Are you sure want to end this configuration?
                        </Typography>
                        <span style={{ textAlign: "center", marginLeft: '20px', fontFamily: 'OpenSans-semibold' }}><span style={{ fontFamily: 'OpenSans-bold' }}>Note: </span> The end date will be updated to yesterday's date</span>
                    </Grid>
                    <Grid style={{ display: "flex", justifyContent: "center", margin: "5%" }}>
                        <RACButton
                            style={{ marginRight: "10%" }}
                            variant="outlined"
                            onClick={() => setPopup(false)}
                        >
                            No
                        </RACButton>
                        <RACButton
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setPopup(false)
                                submitFunction(true);
                            }}
                        >
                            Yes
                        </RACButton>
                    </Grid>
                </Grid>
            </>
        );
    };

    console.log(zoneBasedPricingFormData, 'costBasedPricingFormDatacostBasedPricingFormData')
    return (
        <>
            <Grid container md={12} className={`${classes.pagePadding1}`}>
                <Grid container md={12} style={{ marginBottom: '15px' }}>
                    {breadCrums()}
                </Grid>
                <Grid container style={{ width: '100%' }}>
                    <Grid container style={{ width: '49%', marginRight: '1%' }}>
                        <Grid item md={12} style={{ marginBottom: '10px' }}>
                            <Typography variant='h4'>{isEditScreen ? 'Update Zone Based Pricing' : ' New Zone Based Pricing'}</Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Card className={classes.card} style={{ height: '70vh', overflowY: 'auto' }}>
                                <CardContent style={{ paddingRight: '0px' }}>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '15px' }}>
                                        <Grid item md={4}>
                                            <Typography>Zone<span style={{ color: "red" }}>*</span>
                                            </Typography>
                                            <MultiSelect
                                                isLoading={loader.dropdownLoader}
                                                options={zoneOptions}
                                                className={`${classes.demo} ${classes.prcingzoneMultiSelect}`}
                                                value={formZoneSelected}
                                                disabled={isEditScreen}
                                                labelledBy={"Select"}
                                                hasSelectAll={true}
                                                onChange={(e: any) => {
                                                    setFormZoneSelected(e);
                                                    let arr = e.map((item: any) => {
                                                        if (item.value == item.value) return item.value;
                                                    });
                                                    setZoneBasedPricingFormData({ ...zoneBasedPricingFormData, zoneNumber: arr })
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <RACSelect
                                                inputLabel="Department"
                                                required={true}
                                                defaultValue={zoneBasedPricingFormData?.departmentNumber}
                                                options={deptFormOptions}
                                                isDisabled={isEditScreen}
                                                loading={loader.dropdownLoader}
                                                onChange={(e) => {
                                                    setZoneBasedPricingFormData({
                                                        ...zoneBasedPricingFormData, departmentNumber: e.target.value,
                                                        subdepartmentNumber: '', bracket: ''
                                                    })
                                                    bindHierarchyDropDown(dropDownData?.subdepartment, 'departmentNumber', e.target.value, 'subdepartmentNumber')
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <RACSelect
                                                inputLabel="Sub Department"
                                                defaultValue={zoneBasedPricingFormData?.subdepartmentNumber}
                                                options={subDeptFormOptions}
                                                isDisabled={(isEditScreen) || (zoneBasedPricingFormData?.departmentNumber ? false : true)}
                                                onChange={(e) => {
                                                    setZoneBasedPricingFormData({
                                                        ...zoneBasedPricingFormData,
                                                        subdepartmentNumber: e.target.value, bracket: ''
                                                    })
                                                    bindHierarchyDropDown(dropDownData?.bracket, 'subdepartmentNumber', e.target.value, 'bracketNumber')
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '15px' }}>
                                        <Grid item md={4}>
                                            <RACSelect
                                                inputLabel="Bracket"
                                                defaultValue={zoneBasedPricingFormData?.bracketNumber}
                                                options={bracketFormOptions}
                                                isDisabled={(isEditScreen) || ((zoneBasedPricingFormData?.departmentNumber &&
                                                    zoneBasedPricingFormData?.subdepartmentNumber) ? false : true)}
                                                onChange={(e) => {
                                                    onChangeField('bracketNumber', e.target.value)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <RACDatePicker
                                                required={true}
                                                label="Start date"
                                                errorMessage={errorMessage.startDate}
                                                value={zoneBasedPricingFormData?.startDate}
                                                inputProps={{
                                                    min: ((!isEditScreen) || (isEditScreen && isDeptLevel)) ? moment().format('YYYY-MM-DD') : null,
                                                    max: '2099-12-31',
                                                }}
                                                onChange={(e) => {
                                                    const startDate = moment(e, "YYYY-MM-DD");
                                                    dateValidation(startDate, endDate)
                                                    onChangeField('startDate', e)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <RACDatePicker
                                                label="End date"
                                                required={true}
                                                errorMessage={errorMessage.endDate}
                                                value={zoneBasedPricingFormData?.endDate}
                                                onChange={(e) => {
                                                    const endDate = moment(e, "YYYY-MM-DD");
                                                    dateValidation(startDate, endDate)
                                                    onChangeField('endDate', e)
                                                }
                                                }
                                                inputProps={{
                                                    min: endDateMin,
                                                    max: '2099-12-31',
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} style={{ marginBottom: '15px' }}>
                                        <Grid item md={12}>
                                            <span className={classes.title5}>Do you want to generate new price for existing RMS items?</span>
                                            <span style={{ color: 'red', marginLeft: '5px' }}> * </span>
                                            <Grid style={{ margin: '1%' }}>
                                                <RACRadio
                                                    value={''}
                                                    checked={zoneBasedPricingFormData?.publishPriceForExisitingRMS == 'Yes'}
                                                    label="Yes (Generate new price to existing and future RMS items)"
                                                    name="existingRMS"
                                                    onClick={() => onChangeField('publishPriceForExisitingRMS', 'Yes')}
                                                />
                                                <RACRadio
                                                    value={''}
                                                    checked={zoneBasedPricingFormData?.publishPriceForExisitingRMS == 'No'}
                                                    label="No (Generate new price only to future RMS items)"
                                                    name="existingRMS"
                                                    onClick={() => onChangeField('publishPriceForExisitingRMS', 'No')}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} style={{ marginBottom: '10px' }}>
                                        <Grid item md={12}>
                                            <span className={classes.title5}>How do you want to update the Zone Based Pricing?</span>
                                            <span style={{ color: 'red', marginLeft: '5px' }}> * </span>
                                            <Grid style={{ margin: '1%' }}>
                                                <RACRadio
                                                    value={''}
                                                    checked={zoneBasedPricingFormData?.schedule == 'IMMEDIATE'}
                                                    label="Immediately"
                                                    name="schedule"
                                                    onClick={() => onChangeField('schedule', 'IMMEDIATE')}
                                                />
                                                <RACRadio
                                                    value={''}
                                                    checked={zoneBasedPricingFormData?.schedule == 'OVERNIGHT'}
                                                    label="Overnight"
                                                    name="schedule"
                                                    onClick={() => onChangeField('schedule', 'OVERNIGHT')}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <Grid container style={{ width: '50%' }}>
                        <Grid item md={12} style={{ marginBottom: '10px' }}>
                            <Typography variant='h4'>Zone Based Foundation Rules</Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Card className={classes.card} style={{ height: '70vh', overflowY: 'auto' }}>
                                <CardContent style={{ paddingRight: '0px' }}>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '10px' }}>
                                        <Grid item md={4} className={classes.currencyInputStyle}>
                                            <span className={classes.title5} style={{ marginRight: '5px' }}>New and Used Rate Prem</span>
                                            <RACTooltip
                                                placement={'right'}
                                                classes={{ tooltip: classes.tooltipcss1, arrow: classes.tooltipStyling1 }}
                                                title={
                                                    <span style={{ fontSize: '11px' }}>The entered value will modify both the New Rate and Used Rate by adding or subtracting from them. Sample Value: $2.00, -$1.00</span>
                                                }
                                            >
                                                <Info className={`${classes.width6}`} />
                                            </RACTooltip>
                                            <RACTextbox
                                                type='text'
                                                isCurrency={true}
                                                inputLabelClassname={classes.title3}
                                                value={zoneBasedPricingFormData.newAndUsedRatePrem}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^-?[0-9]*\.?[0-9]+$/, /[^0-9.-]|(?!^)-|(?<=\..*)\./g);
                                                    allowTwoDigitsAfterDot(e)
                                                    onChangeField('newAndUsedRatePrem', e.target.value);
                                                }}
                                                maxlength={7}
                                            />
                                        </Grid>
                                        <Grid item md={4} className={classes.currencyInputStyle}>
                                            <span className={classes.title5} style={{ marginRight: '5px' }}>Brand New Rate Prem</span>
                                            <RACTooltip
                                                placement={'right'}
                                                classes={{ tooltip: classes.tooltipcss1, arrow: classes.tooltipStyling1 }}
                                                title={
                                                    <span style={{ fontSize: '11px' }}>The entered value will only modify New Rate by adding or subtracting from New Rate. Sample Value: $2.00, -$1.00</span>
                                                }
                                            >
                                                <Info className={`${classes.width6}`} />
                                            </RACTooltip>
                                            <RACTextbox
                                                type='text'
                                                isCurrency={true}
                                                inputLabelClassname={classes.title3}
                                                value={zoneBasedPricingFormData.brandNewRatePrem}
                                                placeHolder='Example: 0.09'
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^-?[0-9]*\.?[0-9]+$/, /[^0-9.-]|(?!^)-|(?<=\..*)\./g);
                                                    allowTwoDigitsAfterDot(e)
                                                    onChangeField('brandNewRatePrem', e.target.value);
                                                }}
                                                maxlength={7}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <RACTextbox
                                                type='text'
                                                inputlabel='Total Turns'
                                                placeHolder='Example: 4.008'
                                                inputLabelClassname={classes.title3}
                                                value={zoneBasedPricingFormData.turn}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    allowTwoDigitsBeforeDot(e)
                                                    onChangeField('turn', e.target.value)
                                                }}
                                                maxlength={9}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '10px' }}>
                                        <Grid item md={4}>
                                            <span className={classes.title5} style={{ marginRight: '5px' }}>Term Prem</span>
                                            <RACTooltip
                                                placement={'right'}
                                                classes={{ tooltip: classes.tooltipcss1, arrow: classes.tooltipStyling1 }}
                                                title={
                                                    <span style={{ fontSize: '11px' }}>The entered value will modify the Term by adding or subtracting from the existing Term. Sample Value: 13,-13</span>
                                                }
                                            >
                                                <Info className={`${classes.width6}`} />
                                            </RACTooltip>
                                            <RACTextbox
                                                type='text'
                                                inputLabelClassname={classes.title3}
                                                value={zoneBasedPricingFormData.termPrem}
                                                placeHolder='Example: 13'
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^-?[0-9]+$/, /[^0-9-]|(?!^)-/g);
                                                    allowThreeDigits(e)
                                                    onChangeField('termPrem', e.target.value)
                                                }}

                                                maxlength={4}
                                            />
                                        </Grid>
                                        <Grid item md={4} style={{ marginTop: '28px' }}>
                                            <RACCheckBox
                                                checked={checked}
                                                onChange={(e) => {
                                                    setChecked(!checked)
                                                    setZoneBasedPricingFormData({ ...zoneBasedPricingFormData, reCalculateTerm: e.target?.checked ? 'Yes' : 'No' })
                                                }}
                                            />
                                            <span className={classes.title5}>Recalculate Term</span>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container md={12}>
                {footerCard()}
            </Grid>
            <RACModalCard
                isOpen={popup}
                maxWidth="xs"
                borderRadius={10}
                closeIcon={true}
                onClose={() => setPopup(false)}
            >
                {popUp()}
            </RACModalCard>
        </>
    )
}
